module.exports = __webpack_public_path__ + "img/historia2.015ffe19.jpg";